@if (fullscreen()) {
  <fieldset class="fullscreen">
    <ng-container *ngTemplateOutlet="content" />
  </fieldset>
} @else {
  <fieldset class="u-fade-slide-in">
    <header>
      <h4>{{ 'training_block.header' | translate }}</h4>
      <button
        type="button"
        class="fullscreen-button"
        [tooltip]="'training_block.open_fullscreen' | translate"
        tooltipPosition="left"
        (click)="openFullscreenModal()"
      >
        <kin-icon name="full_screen" />
      </button>
    </header>
    <ng-container *ngTemplateOutlet="content" />
  </fieldset>
}

<ng-template #content>
  @if (contentType() === 'coaching') {
    <app-coaching-intervals-editor [fullscreen]="fullscreen()" [trainingForm]="trainingForm()" />
  } @else if (trainingForm(); as form) {
    @for (revision of [selectsRevision()]; track revision) {
      <div class="sport-and-type-selects">
        @let sportError = form.get('sport')?.invalid && form.get('sport')?.touched;
        <app-select-field
          [label]="'common.sport_placeholder' | translate"
          [filled]="!!sport()"
          [errorMessage]="sportError ? ('common.required_field' | translate) : undefined"
        >
          <kin-select
            name="sport"
            id="sport-select"
            [required]="true"
            [default]="'common.sport_placeholder' | translate"
            [value]="sport()"
            (onSelectedValue)="changeSport($event)"
            [class.error]="sportError"
          >
            @for (sportType of sportTypes; track sportType) {
              <option [value]="sportType">
                {{ 'common.sport.verb.' + sportType | translate | upperFirstLetter }}
              </option>
            }
          </kin-select>
        </app-select-field>

        @for (currentSport of [sport()]; track currentSport) {
          @let workoutModeError =
            form.get('workoutMode')?.invalid && form.get('workoutMode')?.touched;
          <app-select-field
            [label]="'training_block.training_type_label' | translate"
            [filled]="!!workoutMode()"
            [errorMessage]="workoutModeError ? ('common.required_field' | translate) : undefined"
          >
            <kin-select
              [disabled]="!workoutModes()"
              name="training-type"
              id="training-type-select"
              [required]="true"
              [default]="'training_block.training_type_placeholder' | translate"
              [value]="workoutMode()"
              (onSelectedValue)="changeWorkoutMode($event)"
              [class.error]="workoutModeError"
            >
              @for (workoutModeOption of workoutModes(); track workoutModeOption) {
                <option [value]="workoutModeOption">
                  {{ 'common.training_type.' + workoutModeOption | translate | upperFirstLetter }}
                </option>
              }
            </kin-select>
          </app-select-field>
        }
      </div>
    }

    <span class="divider"></span>

    <h3 class="workout-title">
      <kin-icon name="workout_stroke" [size]="20" />
      {{ 'training_block.workout_title' | translate }}
    </h3>

    @let sectionsError = form.get('sections')?.invalid && form.get('sections')?.touched;
    <app-sections-editor
      [errorMessage]="sectionsError ? ('training_block.sections_required' | translate) : undefined"
      contentType="workout"
      [disabled]="disabledEditor()"
      [workoutMode]="workoutMode()"
      [(sections)]="sections"
      [(selectedSectionsIds)]="selectedSectionsIds"
    />
  }
</ng-template>
